// import { BsThreeDotsVertical } from "react-icons/bs";
// import "./Taxes.css";
// import { useState, useEffect } from "react";
// import "react-toastify/dist/ReactToastify.css";
// import { toast, ToastContainer } from "react-toastify";

// function Taxes() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [taxes, setTaxes] = useState([]);
//   const [taxName, setTaxName] = useState("");
//   const [taxRate, setTaxRate] = useState("");
//   const [editIndex, setEditIndex] = useState(null);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteIndex, setDeleteIndex] = useState(null);
//   const [responseData, setResponseData] = useState([]);
//   const [selectedCompID, setSelectedCompID] = useState("");
//   const [selectedCompName, setSelectedCompName] = useState("");

//   const [editableData, setEditableData] = useState({});

//   const handleEdit = (index) => {
//     const selectedTax = taxes[index];
//     setEditableData({ ...selectedTax });
//     setEditIndex(index);
//     setShowEditModal(true);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedCompID || taxName.trim() === "" || taxRate.trim() === "") {
//       toast.error("Please select company and enter Tax Name & Rate.");
//       return;
//     }
 
//     const proxyUrl = "https://thingproxy.freeboard.io/fetch/"; // Or use your own proxy
//     const apiUrl = "http://etour.responseinfoway.com/restapi/insertdata.aspx";

//     const formData = new FormData();
//     formData.append("SecurityKey", "abcd");
//     formData.append("TableName", "taxmaster");
//     formData.append("CompID", selectedCompID); 
//     formData.append("TaxName", taxName);
//     formData.append("TaxRate", taxRate);
      

//     try {
//       const response = await fetch(proxyUrl + apiUrl, {
//         method: "POST",
//         body: formData,
        
//       });

//       const text = await response.text();
//       console.log("🧾 Raw Server Response:", text);

//       let result; 
//       try {
//         result = JSON.parse(text);
//       } catch (err) {
//         // toast.error("Server response is not valid JSON.");
//         return;
//       }

//       if (result?.Status === "Success" || result?.Response === "OK") {
//         toast.success("Tax submitted successfully!");
//         resetForm();
//       } else {
//         toast.success("Tax submitted successfully!");
//       }
//       console.log(Response);
//     } catch (error) {
//       console.warn("❌ Network error:", error);
//       toast.error("Network error. Please try again.");
//     }
//   };
  

//   const handleSaveChanges = async () => {
//     const taxId = taxes[editIndex]?.ID;

//     if (!taxId) return toast.error("Invalid Tax ID.");

//     if (!editableData.TaxName || !editableData.TaxRate) {
//       return toast.warn("Please enter both Tax Name and Rate.");
//     }


//     const formData = new URLSearchParams();
//     formData.append("SecurityKey", "abcd");
//     formData.append("TableName", "Taxmaster");
//     formData.append("WhereCondition", `ID=${taxId}`);
//     formData.append("TaxName", editableData.TaxName);
//     formData.append("TaxRate", editableData.TaxRate);

//     try {
//       const response = await fetch(
//         "http://etour.responseinfoway.com/restapi/updatedata.aspx",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/x-www-form-urlencoded" },
//           body: formData.toString(),
//         }
//       );

//       const textResponse = await response.text();
//       console.log("Edit Response:", textResponse);

//       if (textResponse.toLowerCase().includes("ok")) {
//         toast.success("Tax updated successfully!");
//         window.location.reload();
//       } else {
//         toast.error("❌ Update failed: " + textResponse);
//       }
//     } catch (error) {
//       console.error("Update Error:", error);
//       toast.success("Tax updated successfully!");
//     }
//   };


//     useEffect(() => {
//       if (!selectedCompID) {
//         setTaxes([]); 
//         return;
//       }
  
//       const fetchTaxes = async () => {
//         const proxyUrl = "https://thingproxy.freeboard.io/fetch/";
//         const apiUrl = "http://etour.responseinfoway.com/restapi/Selectdata.aspx";
  
//         const data = new URLSearchParams();
//         data.append("SecurityKey", "abcd");
//         data.append("TableName", "Taxmaster");
//         data.append("WhereCondition", `CompID=${selectedCompID}`);
//         data.append("*", "*");
  
//         try {
//           const response = await fetch(proxyUrl + apiUrl, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/x-www-form-urlencoded",
//             },
//             body: data.toString(),
//           });
  
//           const text = await response.text();
//           let result;
//           try {
//             result = JSON.parse(text);
//           } catch (err) {
//             console.error("❌ Failed to parse JSON:", err);
//             return;
//           }
  
//           if (Array.isArray(result.Response)) {
//             console.log("📦 Taxes Data:", result.Response);
//             setTaxes(result.Response);
//           } else {
//             console.warn("⚠️ Unexpected structure in response:", result);
//             setTaxes([]);
//           }
//         } catch (err) {
//           console.error("❌ Network error while fetching taxes:", err);
//         }
//       };
  
//       fetchTaxes();
//     }, [selectedCompID]);
  

//   // delet

//   const handleDelete = async () => {
//     if (deleteIndex === null || !taxes[deleteIndex]) return;

//     const deleteId = taxes[deleteIndex].ID; // 👈 adjust if ID is named differently

//     const deleteData = new URLSearchParams();
//     deleteData.append("SecurityKey", "abcd");
//     deleteData.append("TableName", "Taxmaster");
//     deleteData.append("WhereCondition", `ID=${deleteId}`); // 👈 critical line

//     try {
//       const response = await fetch(
//         "http://etour.responseinfoway.com/restapi/deletedata.aspx",
//         {
//           method: "POST",
//           headers: {"Content-Type":"application/x-www-form-urlencoded"},
//           body: deleteData.toString(),
//         }
//       );

//       const textResponse = await response.text();
//       console.log("Delete Response:", textResponse);

//       if (
//         textResponse.toLowerCase().includes("deleted") ||
//         textResponse.toLowerCase().includes("success")
//       ) {
//         // Filter out deleted tax from state
//         setTaxes((prevTaxes) => prevTaxes.filter((_, i) => i !== deleteIndex));
//         // setShowDeleteModal(false);
//       } else {
//         throw new Error(`API responded with failure: ${textResponse}`);
//       }
//     } catch (error) {
//       console.error("Delete Error:", error);
//     }
//   };

//   // Compney

//     useEffect(() => {
//       const loggedInUserId = localStorage.getItem("userId");
  
//       const fetchCompanies = async () => {
//         const proxyUrl = "https://thingproxy.freeboard.io/fetch/";
//         const apiUrl = "http://etour.responseinfoway.com/restapi/Selectdata.aspx";
  
//         const data = new URLSearchParams();
//         data.append("SecurityKey", "abcd");
//         data.append("TableName", "company");
//         data.append("WhereCondition", `MasterId=${loggedInUserId}`);
//         data.append("*", "*");
  
//         try {
//           const response = await fetch(proxyUrl + apiUrl, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/x-www-form-urlencoded",
//             },
//             body: data.toString(),
//           });
  
//           const jsonData = await response.json();
//           if (jsonData.Response) {
//             setResponseData(jsonData.Response);
//           } else {
//             toast.error("No companies found.");
//           }
//         } catch (error) {
//           console.error("Error fetching companies:", error);
//         }
//       };
  
//       fetchCompanies();
//     }, []);


//   const handleCompanyChange = (e) => {
//     const compId = e.target.value;
//     setSelectedCompID(compId);

//     const selected = responseData.find((c) => c.CompID.toString() === compId);
//     setSelectedCompName(selected?.Name || "");
//   };

//   const resetForm = () => {
//     setTaxName("");
//     setTaxRate("");
//     setSelectedCompID("");
//     setSelectedCompName("");
//   };

//   return (
//     <>
//       <div className="container-fluid">
//         <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

//         <div className="Taxes">
//           <div className="Taxes_maintext">
//             <h6>TAXES</h6>
//             <div>
//               <p>Taxes</p>
//               <span>
//                 <i className="fa-solid fa-chevron-right"></i>Invoice
//               </span>
//             </div>
//           </div>
//           <div className="button_search-text">
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add Taxes
//             </button>

//             <div>
//               <input
//                 type="search"
//                 className="form-control"
//                 placeholder="Search for name or designation..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               <span>
//                 <BsThreeDotsVertical />
//               </span>
//             </div>
//           </div>

//           <div className="Addtext_Details-colom">
//             <h2 className="text-xl font-semibold text-gray-700 mb-4 ">
//               Add Tax Details
//             </h2>
//             {/* Form */}
//             <form onSubmit={handleSubmit}>
//               <div className="form_table-container">
//                 {/* Taxes Name Input */}
//                 <div className=" w-40 ">
//                   <label className="block text-gray-600 text-sm font-medium ">
//                     Select Compny
//                   </label>

//                   <select
//                     className="w-full border rounded outline outline-none  mt-2 text-sm p-1  text-gray-600 "
//                     value={selectedCompID}
//                     onChange={handleCompanyChange}
//                   >
//                     <option value="">Select Company</option>
//                     {responseData.map((company) => (
//                       <option key={company.CompID} value={company.CompID}>
//                         {company.Name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 <div className=" w-20 ml-10">
//                   <label className="block text-gray-600 text-sm font-medium ">
//                     Tax Name
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="Taxes Name"
//                     value={taxName}
//                     onChange={(e) => setTaxName(e.target.value)}
//                     className="w-20 border rounded outline outline-none m-0 mt-2 "
//                   />
//                 </div>

//                 {/* Taxes Rate Input */}

//                 <div className=" w-24">
//                   <label className="block text-gray-600 text-sm font-medium">
//                     Tax Rate (%)
//                   </label>
//                   <input
//                     type="text"
//                     placeholder="Taxes Rate"
//                     value={taxRate}
//                     onChange={(e) => setTaxRate(e.target.value)}
//                     className="w-20 border rounded outline outline-none  mt-2 "
//                   />
//                 </div>
//                 <div className="submit_button-taxes">
//                   <button type="submit">Save</button>
//                 </div>
//               </div>
//             </form>
//           </div>

//           {taxes.length > 0 && (
//             <div className="text_rare-table">
//               <table className="w-full border border-gray-300">
//                 <thead>
//                   <tr className="bg-gray-200">
//                     <th className="p-2 border text-center">Taxes Name</th>
//                     <th className="p-2 border text-center">Taxes Rate (%)</th>
//                     <th className="p-2 border text-center">Edit</th>
//                     <th className="p-2 border text-center">Delete</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {taxes.map((tax, index) => (
//                     <tr key={index} className="text-center">
//                       <td className="p-2 border">{tax.TaxName}</td>
//                       <td className="p-2 border">{tax.TaxRate}</td>
//                       <td
//                         className="border"
//                         data-bs-toggle="modal"
//                         data-bs-target="#taxes_editmodel-taxes"
//                       >
//                         <i
//                           id="update_taxes"
//                           className="fa-solid fa-pen"
//                           onClick={() => handleEdit(index)}
//                         ></i>
//                       </td>
//                       <td
//                         className="border"
//                         data-bs-toggle="modal"
//                         data-bs-target="#taxes_deletmodelt-axes"
//                       >
//                         <i
//                           id="delet_taxes"
//                           className="fa-solid fa-trash"
//                           onClick={() => {
//                             setDeleteIndex(index);
//                             setShowDeleteModal(true);
//                           }}
//                         ></i>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* delet model  */}

//       <div
//         className="modal fade"
//         id="taxes_deletmodelt-axes"
//         tabindex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="close_topbutton-taxes">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>

//             <div className="delet_icon-boxtaxes">
//               <i className="fa-solid fa-trash"></i>
//             </div>
//             <div className="taxes_pcolom">
//               <h6>Confirm Delete</h6>
//               <p>Are you sure you want to delete</p>
//             </div>

//             <div className="close_bottombutton-taxes">
//               <button
//                 type="button"
//                 className="cencle_button"
//                 data-bs-dismiss="modal"
//                 onClick={() => setShowDeleteModal(false)}
//               >
//                 Cancel
//               </button>
//              <button
//                 type="button"
//                 className="delete_button"
//                 data-bs-dismiss="modal"
//                 onClick={handleDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Edit model */}

//       <div
//         className="modal fade"
//         id="taxes_editmodel-taxes"
//         tabindex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content adit_model-container">
//             <div className="close_topbutton-taxes">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>

//             <div className="taxes_modal-body">
//               <h6>Edit Taxes</h6>
//               <div className="taxes_modal-input">
//                 <input
//                   type="text"
//                   placeholder="Taxes Name"
//                   value={editableData.TaxName}
//                   onChange={(e) =>
//                     setEditableData({
//                       ...editableData,
//                       TaxName: e.target.value,
//                     })
//                   }
//                 />

//                 <input
//                   type="text"
//                   placeholder="Taxes Rate (%)"
//                   value={editableData.TaxRate || ""}
//                   onChange={(e) =>
//                     setEditableData({
//                       ...editableData,
//                       TaxRate: e.target.value,
//                     })
//                   }
//                 />
//               </div>
//             </div>

//             <div className="edit_bottombutton-taxes">
//               <button
//                 type="button"
//                 className="cencl_button"
//                 data-bs-dismiss="modal"
//                 onClick={() => setShowEditModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="edit_button"
//                 data-bs-dismiss="modal"
//                 onClick={handleSaveChanges}
//               >
//                 Edit
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Taxes;









import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../utils/customToast";
import { SECURITY_KEY } from "../../globals";
import { apiWithLog } from "../../utils/apiWithLog";
import DeleteConfirmModal from "../DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../Skeleton";
import "../../Masters/Master/Ledger/ShowLedger.css";
import "../../Masters/Master/Ledger/UpdateLedger.css";

function Taxes() {
  const [searchTerm, setSearchTerm] = useState("");
  const [taxes, setTaxes] = useState([]);
  const [taxName, setTaxName] = useState("");
  const [taxRate, setTaxRate] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [responseData, setResponseData] = useState([]);
  const [selectedCompID, setSelectedCompID] = useState("");
  const [selectedCompName, setSelectedCompName] = useState("");
  const [editableData, setEditableData] = useState({});
  const [loading, setLoading] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // 🔹 Auto-load company from localStorage
  useEffect(() => {
    const syncCompany = () => {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      if (company?.id && !selectedCompID) {
        setSelectedCompID(company.id.toString());
        setSelectedCompName(company.name || "");
      }
    };
    syncCompany();
  }, [selectedCompID]);

  // Fetch Taxes by Company
  const fetchTaxes = async (compId) => {
    if (!compId) {
      setTaxes([]);
      return;
    }

    const data = new URLSearchParams();
    data.append("SecurityKey", SECURITY_KEY);
    data.append("TableName", "Taxmaster");
    data.append("WhereCondition", `CompID=${compId}`);
    data.append("*", "*");

    try {
      setLoading(true);
      const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      const result = await response.json();
      if (result.Response && Array.isArray(result.Response)) {
        setTaxes(result.Response);
      } else {
        setTaxes([]);
      }
    } catch (err) {
      console.error("Error fetching taxes:", err);
      setTaxes([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Companies
  useEffect(() => {
    const loggedInUserId = localStorage.getItem("userId");

    const fetchCompanies = async () => {
      const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
      const data = new URLSearchParams();
      data.append("SecurityKey", SECURITY_KEY);
      data.append("TableName", "company");
      data.append("WhereCondition", `MasterId=${loggedInUserId}`);
      data.append("*", "*");

      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: data.toString(),
        });

        const jsonData = await response.json();
        if (jsonData.Response) {
          setResponseData(jsonData.Response);

          // If no company is selected yet, default to first company or localStorage
          const localComp = JSON.parse(localStorage.getItem("selectedCompany"));
          if (localComp?.id) {
            setSelectedCompID(localComp.id.toString());
            setSelectedCompName(localComp.name || "");
          } else if (jsonData.Response.length > 0) {
            setSelectedCompID(jsonData.Response[0].CompID.toString());
            setSelectedCompName(jsonData.Response[0].Name || "");
          }
        } else {
          showToast.error("No companies found.");
        }
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, [BASE_REST_API_URL]);

  useEffect(() => {
    if (selectedCompID) {
      fetchTaxes(selectedCompID);
    }
  }, [selectedCompID]);

  const handleCompanyChange = (e) => {
    const compId = e.target.value;
    setSelectedCompID(compId);

    const selected = responseData.find((c) => c.CompID.toString() === compId);
    setSelectedCompName(selected?.Name || "");
    setCurrentPage(1);
  };

  // Add Tax Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!selectedCompID || taxName.trim() === "" || taxRate.trim() === "") {
      showToast.error("Please select company and enter Tax Name & Rate.");
      return;
    }

    const formData = new URLSearchParams();
    formData.append("SecurityKey", SECURITY_KEY);
    formData.append("TableName", "Taxmaster");
    formData.append("CompID", selectedCompID);
    formData.append("TaxName", taxName);
    formData.append("TaxRate", taxRate);

    const apiUrl = `${BASE_REST_API_URL}/insertdata.aspx`;

    try {
      setLoading(true);

      const res = await apiWithLog({
        method: "POST",
        url: apiUrl,
        data: formData.toString(),
        module: "Taxes",
        action: "A",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      let result = res?.data || res;
      if (typeof result === "string") {
        try {
          result = JSON.parse(result);
        } catch {
          console.log("Server returned text response:", result);
        }
      }

      showToast.save("Tax added successfully!");
      setTaxName("");
      setTaxRate("");
      fetchTaxes(selectedCompID);

    } catch (err) {
      console.error("Error adding tax:", err);
      showToast.error("Failed to add tax.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index) => {
    const selectedTax = filteredTaxes[index];
    setEditableData({ ...selectedTax });
    setEditIndex(index);
    setShowEditModal(true);
  };

  const handleSaveChanges = async (e) => {
    if (e) e.preventDefault();
    if (loading) return;
    const taxId = editableData?.ID;

    if (!taxId) {
      showToast.error("Invalid Tax ID.");
      return;
    }

    if (!editableData.TaxName || !editableData.TaxRate) {
      showToast.warn("Please enter both Tax Name and Rate.");
      return;
    }

    const formData = new URLSearchParams();
    formData.append("SecurityKey", SECURITY_KEY);
    formData.append("TableName", "Taxmaster");
    formData.append("WhereCondition", `ID=${taxId}`);
    formData.append("TaxName", editableData.TaxName);
    formData.append("TaxRate", editableData.TaxRate);

    const apiUrl = `${BASE_REST_API_URL}/updatedata.aspx`;

    try {
      setLoading(true);

      const res = await apiWithLog({
        method: "POST",
        url: apiUrl,
        data: formData.toString(),
        module: "Taxes",
        action: "E",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      showToast.save("Tax updated successfully!");
      setShowEditModal(false);
      fetchTaxes(selectedCompID);

    } catch (error) {
      console.error("Update Error:", error);
      showToast.error("Failed to update tax.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (loading) return;
    if (deleteIndex === null || !filteredTaxes[deleteIndex]) return;

    const deleteId = filteredTaxes[deleteIndex].ID;

    const deleteData = new URLSearchParams();
    deleteData.append("SecurityKey", SECURITY_KEY);
    deleteData.append("TableName", "Taxmaster");
    deleteData.append("WhereCondition", `ID=${deleteId}`);

    const deleteUrl = `${BASE_REST_API_URL}/deletedata.aspx`;

    try {
      setLoading(true);

      await apiWithLog({
        method: "POST",
        url: deleteUrl,
        data: deleteData.toString(),
        module: "Taxes",
        action: "D",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      showToast.delete("Tax deleted successfully!");
      setDeleteIndex(null);
      setShowDeleteModal(false);
      fetchTaxes(selectedCompID);

    } catch (error) {
      console.error("Delete Error:", error);
      showToast.error("Network error during deletion.");
    } finally {
      setLoading(false);
    }
  };

  // Filtered Taxes
  const filteredTaxes = taxes.filter((t) => {
    if (!searchTerm) return true;
    const lower = searchTerm.toLowerCase();
    return (
      (t.TaxName && t.TaxName.toLowerCase().includes(lower)) ||
      (t.TaxRate && t.TaxRate.toString().toLowerCase().includes(lower))
    );
  });

  // Pagination
  const totalPages = Math.ceil(filteredTaxes.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredTaxes.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <div className="ledger_page_container">
      {/* TOP HEADER & BREADCRUMBS */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h4 className="ledger_header_title">Tax Master</h4>
          <div className="ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <span>Master</span>
            <span>/</span>
            <span>Taxes</span>
          </div>
        </div>
      </div>

      {/* FORM CARD: ADD TAX DETAILS */}
      <div className="update_ledger_card mb-4">
        <div className="update_ledger_card_header">
          <h5>Add Tax Details</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            <div className="update_ledger_field">
              <label htmlFor="companySelect">
                Select Company <span className="required">*</span>
              </label>
              <select
                id="companySelect"
                value={selectedCompID}
                onChange={handleCompanyChange}
                required
              >
                <option value="">-- Select Company --</option>
                {responseData.map((company) => (
                  <option key={company.CompID} value={company.CompID}>
                    {company.Name}
                  </option>
                ))}
              </select>
            </div>

            <div className="update_ledger_field">
              <label htmlFor="taxName">
                Tax Name <span className="required">*</span>
              </label>
              <input
                id="taxName"
                type="text"
                placeholder="e.g. CGST, SGST, IGST"
                value={taxName}
                onChange={(e) => setTaxName(e.target.value)}
                required
              />
            </div>

            <div className="update_ledger_field">
              <label htmlFor="taxRate">
                Tax Rate (%) <span className="required">*</span>
              </label>
              <input
                id="taxRate"
                type="number"
                step="0.01"
                placeholder="e.g. 18"
                value={taxRate}
                onChange={(e) => setTaxRate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="update_ledger_actions">
            <button
              type="button"
              className="update_ledger_cancel_btn"
              onClick={() => {
                setTaxName("");
                setTaxRate("");
              }}
            >
              Reset
            </button>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "+ Save Tax"}
            </button>
          </div>
        </form>
      </div>

      {/* TOP CONTROLS */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <span style={{ fontWeight: 600, color: "#475569", fontSize: "11.5px" }}>
            Configured Taxes ({filteredTaxes.length})
          </span>
        </div>

        <div className="ledger_top_right">
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search taxes..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={5} rows={6} hasToolbar={false} />
        )}

        {!loading && filteredTaxes.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    <th style={{ width: "60px", textAlign: "center" }}>Sl. No</th>
                    <th>Tax Name</th>
                    <th>Tax Rate (%)</th>
                    <th>Company</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((tax, index) => (
                    <tr key={tax.ID || index}>
                      <td style={{ textAlign: "center", color: "#64748b" }}>
                        {(currentPage - 1) * recordsPerPage + index + 1}
                      </td>
                      <td className="ledger_name_cell">{tax.TaxName}</td>
                      <td>{tax.TaxRate}%</td>
                      <td>{selectedCompName || `Company #${tax.CompID}`}</td>
                      <td className="ledger_actions_cell">
                        <button
                          type="button"
                          className="ledger_btn_edit"
                          title="Edit Tax"
                          onClick={() => handleEdit((currentPage - 1) * recordsPerPage + index)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                        <button
                          type="button"
                          className="ledger_btn_delete"
                          title="Delete Tax"
                          onClick={() => {
                            setDeleteIndex((currentPage - 1) * recordsPerPage + index);
                            setShowDeleteModal(true);
                          }}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Showing {indexOfFirstRecord + 1} to{" "}
                {Math.min(indexOfLastRecord, filteredTaxes.length)} of{" "}
                {filteredTaxes.length} records
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && filteredTaxes.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Taxes Found</h6>
            <p>
              {searchTerm
                ? `No taxes matching "${searchTerm}"`
                : selectedCompID
                ? "No taxes configured for the selected company. Use the form above to add taxes."
                : "Please select a company above to view its taxes."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
        title="Delete Tax?"
        message="Are you sure you want to delete this tax? It will no longer be available for service selection and invoices."
        itemName={deleteIndex !== null && filteredTaxes[deleteIndex] ? `${filteredTaxes[deleteIndex].TaxName} (${filteredTaxes[deleteIndex].TaxRate}%)` : ""}
        loading={loading}
      />

      {/* Pixel-Perfect Edit Modal */}
      {showEditModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(15, 23, 42, 0.5)",
            backdropFilter: "blur(3px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
            padding: "20px",
          }}
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="update_ledger_card"
            style={{
              maxWidth: "500px",
              width: "100%",
              margin: 0,
              boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="update_ledger_card_header">
              <h5>Edit Tax</h5>
            </div>

            <form onSubmit={handleSaveChanges}>
              <div style={{ padding: "20px" }}>
                <div className="update_ledger_field mb-3">
                  <label htmlFor="editTaxName">
                    Tax Name <span className="required">*</span>
                  </label>
                  <input
                    id="editTaxName"
                    type="text"
                    placeholder="Taxes Name"
                    value={editableData.TaxName || ""}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        TaxName: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="update_ledger_field">
                  <label htmlFor="editTaxRate">
                    Tax Rate (%) <span className="required">*</span>
                  </label>
                  <input
                    id="editTaxRate"
                    type="number"
                    step="0.01"
                    placeholder="Taxes Rate (%)"
                    value={editableData.TaxRate || ""}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        TaxRate: e.target.value,
                      })
                    }
                    required
                  />
                </div>
              </div>

              <div className="update_ledger_actions">
                <button
                  type="button"
                  className="update_ledger_cancel_btn"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="update_ledger_submit_btn"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Taxes;
